import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadAllBrands";
import { BrandCollectionModel, BrandModel } from "@insite/client-framework/Types/ApiModels";
import { getBrands, GetBrandsApiParameter } from "@tCentro/Services/BrandServiceExtension";

type Parameter = Omit<GetBrandsApiParameter, "page"> & {
    /**
     * @deprecated This property is ignored. Loading all brands starting from a page is not supported.
     */
    page?: number;
};

type HandlerType = HandlerWithResult<Parameter, BrandModel[]>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    const pages: BrandModel[][] = [];
    const pageSize = props.parameter.pageSize || 500;
    const getPage = async (page: number) => {
        const parameter = {
            ...props.parameter,
            pageSize,
            page,
        };
        const apiResult = await getBrands(parameter);
        pages[page] = apiResult.brands!;
        return apiResult;
    };

    const { pagination } = await getPage(1);
    const promises = [];
    for (let x = 2; (x - 1) * pageSize < pagination!.totalItemCount; x++) {
        promises.push(getPage(x));
    }
    await Promise.all(promises);

    let collection: BrandModel[] = [];
    for (const page of pages) {
        if (!page) {
            continue;
        }
        collection = collection.concat(page);
    }

    props.result = collection;
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);
